const getProductCategoryMapping = () => {
  const mappingCategory = [];
  mappingCategory[1] = 'website';
  mappingCategory[2] = 'mobile';
  mappingCategory[3] = 'writing';
  mappingCategory[4] = 'design';
  mappingCategory[5] = 'data';
  mappingCategory[6] = 'product';
  mappingCategory[7] = 'sales';
  mappingCategory[8] = 'business';
  return mappingCategory;
};

// For perfect audience tracking
const paTrack = (mappedString, trackPrefixKey) => {
  window._pq = window._pq || [];
  if (!trackPrefixKey) {
    trackPrefixKey = 'skill_cat_';
  }
  window._pq.push(['track', trackPrefixKey + mappedString]);
};

// For fb tracking
const fbTrack = (mappedString, trackKey) => {
  if (!trackKey) {
    trackKey = 'SkillCategory';
  }
  window._fbq.push(['track', trackKey, { cat: mappedString }]);
};

const trackMappedCategory = (selectedCategory) => {
  const productMapping = getProductCategoryMapping();
  if (typeof productMapping[selectedCategory] !== 'undefined') {
    paTrack(productMapping[selectedCategory]);
    fbTrack(productMapping[selectedCategory]);
  }
};

// For perfect audience tracking
const paTrack2 = (actionKey, trackKey) => {
  window._pq = window._pq || [];
  if ((!actionKey) || (typeof actionKey !== 'string')) {
    actionKey = 'track';
  }
  window._pq.push([actionKey, trackKey]);
};

// For fb tracking
const fbTrack2 = (actionKey, trackKey, objToPass) => {
  window._fbq = window._fbq || [];
  if ((!actionKey) || (typeof actionKey !== 'string')) {
    actionKey = 'track';
  }
  if (!objToPass) {
    objToPass = {};
  }
  window._fbq.push([actionKey, trackKey, objToPass]);
};

const executedCalls = [];

let track;

const retargetingTracking = {
  trackMappedCategory,
  paTrack2,
  fbTrack2,
  sendRetargetingEvents: {
    track,
  },
};

const basicCall = (pageType, intentKey) => {
  if (Array.indexOf.call(executedCalls, intentKey) == -1) {
    retargetingTracking.paTrack2('track', `intent_${pageType}_${intentKey}`);
    retargetingTracking.fbTrack2('track', pageType, { intent: intentKey });
    executedCalls.push(intentKey);
  }
};

track = (element, pageType, intentKey, eventToUse) => {
  element.on(eventToUse, () => {
    basicCall(pageType, intentKey);
  });
};

export default retargetingTracking;
